<template lang="pug">
.calendar-input-modal
  b-modal(v-model="_modalShow" size="lg" no-close-on-backdrop no-close-on-esc @cancel="cancel")
    div(slot="modal-title")
      b {{ modalTitle }}

    .calendar-input-modal-body
      .note(style="margin: 0 20px 20px 20px;")
        span オリジナル予定を登録すると、カレンダーに表示することが出来ます。
        br
        span カレンダーで登録したオリジナル予定をクリックすると、予定の編集・削除が出来ます。

      .register-body
        FormDatetimePicker(v-model="_startDatetime" :date.sync="_startDatetimeDate" :time.sync="_startDatetimeTime"
          key-name="開始日時" name="start-date" placeholder="開始日時" :validation-rules="{ required: true }" required)
        FormDatetimePicker(v-model="_endDatetime" :date.sync="_endDatetimeDate" :time.sync="_endDatetimeTime"
          key-name="終了日時" name="end-date" placeholder="終了日時" :validation-rules="{ required: true }" :disabled="!_startDatetime" required)
        FormInput(key-name="タイトル" name="title" v-model="_title" type="text" placeholder="タイトル"
          :validation-rules="{ required: true, max: 32 }" :maxlength="32" :styles="{ width: '340px' }" required)
        FormTextarea(key-name="内容" name="text" v-model="_text" placeholder="予定の内容を入力してください"
          :validation-rules="{ max: 1000 }" :maxlength="1000" :styles="{ maxWidth: '720px', width: '720px', minHeight: '160px' }")
        .register-row
          .register-group
            .register-key
              span.key-name 色
              span.validation-label 必須
            .register-value
              b-form-select(v-model="_color" :style="getStyle(color)")
                b-form-select-option(v-for="i in 10" :key="i" :value="i" :style="getStyle(i)")
        InputFilterType(v-model="_filterType" :filterResidentGroups.sync="_residentGroups")

    .calendar-input-modal-footer(slot="modal-footer" slot-scope="{ ok, cancel }" style="width:100%;")
      ValidationAlert(v-model="showValidationAlert")
      .buttons.d-flex.justify-content-end(v-if="modelType == 1")
        button.btn.modal-ok-btn(type="button" @click="onRegister()") 登録
        button.btn.modal-cancel-btn(type="button" @click="cancel()") キャンセル
      .buttons.d-flex.justify-content-end(v-if="modelType == 2")
        button.btn.modal-ok-btn(type="button" @click="onUpdate()") 更新
        button.btn.modal-ok-btn(type="button" @click="onDelete()") 削除
        button.btn.modal-cancel-btn(type="button" @click="cancel()") キャンセル
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

import { CalendarFilterType } from "@/commons/services/CalendarEvents";

import ValidationAlert from "@/pc/basics/ValidationAlertByValidator.vue";
import FormDatetimePicker from "@/pc/components/forms/FormDatetimePicker.vue";
import FormInput from "@/pc/components/forms/FormInput.vue";
import FormTextarea from "@/pc/components/forms/FormTextarea.vue";
import InputFilterType from "@/pc/components/reports/InputFilterType.vue";

/**
 * メッセージ送信確認モーダル
 */
@Component({
  components: {
    ValidationAlert,
    FormDatetimePicker,
    FormInput,
    FormTextarea,
    InputFilterType
  },
  $_veeValidate: { validator: "new" }
})
export default class CalendarInputModal extends Vue {
  @Prop({
    default: () => {
      return false;
    }
  })
  value!: boolean;

  @Prop({
    default: () => {
      return "";
    }
  })
  modalTitle!: string;

  @Prop()
  modelType!: CalendarInputModalType;

  @Prop()
  startDatetime!: number;
  @Prop()
  startDatetimeDate!: string;
  @Prop()
  startDatetimeTime!: string;

  @Prop()
  endDatetime!: number;
  @Prop()
  endDatetimeDate!: string;
  @Prop()
  endDatetimeTime!: string;

  @Prop()
  title!: string;
  @Prop()
  text!: string;
  @Prop()
  color!: number;
  @Prop()
  filterType!: CalendarFilterType;
  @Prop()
  residentGroups!: Array<number>;

  /** バリデーションアラート表示可否 */
  showValidationAlert: boolean = false;

  get _modalShow(): boolean {
    return this.value;
  }
  set _modalShow(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }

  get _startDatetime(): number | null {
    return this.startDatetime;
  }
  set _startDatetime(newValue: number | null) {
    this.$emit("update:startDatetime", newValue);
    return;
  }

  get _startDatetimeDate(): string {
    return this.startDatetimeDate;
  }
  set _startDatetimeDate(newValue: string) {
    this.$emit("update:startDatetimeDate", newValue);
    return;
  }

  get _startDatetimeTime(): string {
    return this.startDatetimeTime;
  }
  set _startDatetimeTime(newValue: string) {
    this.$emit("update:startDatetimeTime", newValue);
    return;
  }

  get _endDatetime(): number | null {
    return this.endDatetime;
  }
  set _endDatetime(newValue: number | null) {
    this.$emit("update:endDatetime", newValue);
    return;
  }

  get _endDatetimeDate(): string {
    return this.endDatetimeDate;
  }
  set _endDatetimeDate(newValue: string) {
    this.$emit("update:endDatetimeDate", newValue);
    return;
  }

  get _endDatetimeTime(): string {
    return this.endDatetimeTime;
  }
  set _endDatetimeTime(newValue: string) {
    this.$emit("update:endDatetimeTime", newValue);
    return;
  }

  get _title(): string {
    return this.title;
  }
  set _title(newValue: string) {
    this.$emit("update:title", newValue);
    return;
  }

  get _text(): string {
    return this.text;
  }
  set _text(newValue: string) {
    this.$emit("update:text", newValue);
    return;
  }

  get _color(): number {
    return this.color;
  }
  set _color(newValue: number) {
    this.$emit("update:color", newValue);
    return;
  }

  get _filterType(): CalendarFilterType {
    return this.filterType;
  }
  set _filterType(newValue: CalendarFilterType) {
    this.$emit("update:filterType", newValue);
    return;
  }

  get _residentGroups(): number[] {
    if (!this.residentGroups) {
      return [];
    }
    return this.residentGroups;
  }
  set _residentGroups(newValue: number[]) {
    this.$emit("update:residentGroups", newValue);
    return;
  }

  getStyle(index: number): string {
    switch (index) {
      case 1: {
        return "background-color:#646464; color:#FFFFFF; width:260px; max-width:260px;";
      }
      case 2: {
        return "background-color:#E87B7B; color:#1E1E1E; width:260px; max-width:260px;";
      }
      case 3: {
        return "background-color:#F68DC2; color:#1E1E1E; width:260px; max-width:260px;";
      }
      case 4: {
        return "background-color:#D098EB; color:#1E1E1E; width:260px; max-width:260px;";
      }
      case 5: {
        return "background-color:#7194D6; color:#1E1E1E; width:260px; max-width:260px;";
      }
      case 6: {
        return "background-color:#4AD9E9; color:#1E1E1E; width:260px; max-width:260px;";
      }
      case 7: {
        return "background-color:#C9F4F9; color:#1E1E1E; width:260px; max-width:260px;";
      }
      case 8: {
        return "background-color:#A0E393; color:#1E1E1E; width:260px; max-width:260px;";
      }
      case 9: {
        return "background-color:#EDC575; color:#1E1E1E; width:260px; max-width:260px;";
      }
      case 10: {
        return "background-color:#FEECCA; color:#1E1E1E; width:260px; max-width:260px;";
      }
    }
    return "";
  }

  public async onRegister(): Promise<void> {
    const validationResult: boolean = await this.$validator.validateAll();
    const validationStartEndResult: boolean = this.validateStartEnd(this.startDatetime, this.endDatetime);
    const validationTarget: boolean = this.validateTarget(this.filterType, this.residentGroups);
    if (validationResult && validationStartEndResult && validationTarget) {
      this.showValidationAlert = false;
      this.$emit("onRegister");
    } else {
      this.showValidationAlert = true;
    }

    return;
  }

  /**
   * ### 開始日時・終了日時のバリデーション
   *
   * - 開始日時が終了日時よりも未来ならエラーとして扱う
   * - エラーではない(true)、エラー(false)
   */
  public validateStartEnd(startDatetime: number | null, endDatetime: number | null): boolean {
    if (startDatetime == null || endDatetime == null) {
      return true;
    } else {
      if (endDatetime < startDatetime) {
        this.$validator.errors.add({ field: "start-date", msg: "開始日時が終了日時より未来です" });
        return false;
      } else {
        return true;
      }
    }
  }

  /**
   * ### 予定範囲（利用者グループ）バリデーション
   */
  public validateTarget(filterType: CalendarFilterType, residentGroups: Array<number>): boolean {
    this.$validator.errors.remove("resident-groups");
    // 施設全体ならチェック不要
    if (filterType == CalendarFilterType.FACILITY) {
      return true;
    }
    // 利用者グループの場合、利用者グループが1件以上選択されていればOK
    else if (residentGroups != null && 0 < residentGroups.length) {
      return true;
    }
    // エラーを登録する
    this.$validator.errors.add({ field: "resident-groups", msg: "利用者グループは必須項目です" });
    return false;
  }

  public async onUpdate(): Promise<void> {
    const validationResult: boolean = await this.$validator.validateAll();
    const validationStartEndResult: boolean = this.validateStartEnd(this.startDatetime, this.endDatetime);
    if (validationResult && validationStartEndResult) {
      this.showValidationAlert = false;
      this.$emit("onUpdate");
    } else {
      this.showValidationAlert = true;
    }
    return;
  }

  public onDelete(): void {
    this.showValidationAlert = false;
    this.$emit("onDelete");
    return;
  }

  public cancel(): void {
    this.showValidationAlert = false;
    // 何故かここで消さないとモーダルを再表示した際にエラーが表示されるので削除する
    this.$validator.errors.remove("resident-groups");
    return;
  }
}

export enum CalendarInputModalType {
  /** 不明 */
  UNKNOWN = 0,
  /** 登録 */
  REGISTER = 1,
  /** 編集 */
  EDIT = 2
}
</script>
